import { StyleSheet } from 'react-native'
import { disabledGray, toqueColor, white } from '../../theme/colors'
import { DOBRA } from '../../theme/fonts'

export const styles = StyleSheet.create({
  container: {
    backgroundColor: white,
    borderRadius: 30,
    position: 'absolute',
    bottom: 0,
    width: '100%',
  },

  saveButton: {
    borderRadius: 15,
    height: 53,
    borderWidth: 1,
    borderColor: toqueColor,
    marginRight: 10,
    justifyContent: 'center',
  },

  textSaveButton: {
    color: toqueColor,
    fontFamily: DOBRA,
    fontSize: 17,
    textAlign: 'center',
    fontWeight: 'bold',
  },

  sendbutton: {
    borderRadius: 15,
    height: 53,
    borderWidth: 1,
    borderColor: toqueColor,
    marginRight: 10,
    justifyContent: 'center',
    backgroundColor: toqueColor,
  },

  textSendButton: {
    color: white,
    fontFamily: DOBRA,
    fontSize: 17,
    textAlign: 'center',
    fontWeight: 'bold',
  },

  loading: {
    borderRadius: 15,
    height: 53,
    textAlign: 'center',
    padding: 10,
    backgroundColor: disabledGray,
    borderColor: disabledGray,
  },
})
